import useTreeContext from '../context/useTreeContext';
import TreeItemGroup from './TreeItemGroup';

interface TreeProps {
  label: string;
}

export default function Tree({ label }: Readonly<TreeProps>) {
  const { treeNodes } = useTreeContext();

  return <TreeItemGroup nodes={treeNodes} label={label} level={0} />;
}
